// Réponses de l'onboarding (fournisseur, consommation), rangées PAR COMPTE.
// La référence est le compte Supabase de l'utilisateur (ses métadonnées), donc les réponses
// le suivent sur tous ses appareils. Le navigateur n'en garde qu'une copie, pour l'affichage.
import { SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY } from './passwordReset';

const doneKey = (userId) => `nowatt_onboarding_done:${userId}`;
const dataKey = (userId) => `nowatt_onboarding:${userId}`;

export function isOnboardingDone(userId) {
  if (!userId) return false;
  try { return localStorage.getItem(doneKey(userId)) === 'true'; } catch { return false; }
}

export function getOnboarding(userId) {
  if (!userId) return null;
  try { return JSON.parse(localStorage.getItem(dataKey(userId)) || 'null'); } catch { return null; }
}

export function saveOnboarding(userId, data) {
  if (!userId) return;
  try {
    if (data) localStorage.setItem(dataKey(userId), JSON.stringify(data));
    localStorage.setItem(doneKey(userId), 'true');
    // Anciennes clés communes à tout le navigateur : on les retire
    localStorage.removeItem('nowatt_onboarding');
    localStorage.removeItem('nowatt_onboarding_done');
  } catch { /* stockage indisponible : l'onboarding sera simplement reproposé */ }
}

// ── Synchronisation avec le compte ──────────────────────────────────────────

const authHeaders = (token) => ({
  'Content-Type': 'application/json',
  apikey: SUPABASE_PUBLISHABLE_KEY,
  Authorization: `Bearer ${token}`,
});

// Lit les réponses enregistrées dans le compte.
// Retourne { status: 'ok', data } (data null si rien n'est enregistré),
// { status: 'unauthorized' } si le jeton a expiré, ou { status: 'error' }.
export async function loadRemoteOnboarding(token) {
  try {
    const res = await fetch(`${SUPABASE_URL}/auth/v1/user`, { headers: authHeaders(token) });
    if (res.status === 401 || res.status === 403) return { status: 'unauthorized' };
    if (!res.ok) return { status: 'error' };
    const user = await res.json();
    const o = user?.user_metadata?.onboarding;
    return { status: 'ok', data: o && o.done ? { supplier: o.supplier ?? null, kwh: o.kwh ?? null } : null };
  } catch { return { status: 'error' }; }
}

// Enregistre les réponses dans le compte. Retourne true si c'est fait.
export async function pushRemoteOnboarding(token, data) {
  try {
    const res = await fetch(`${SUPABASE_URL}/auth/v1/user`, {
      method: 'PUT',
      headers: authHeaders(token),
      body: JSON.stringify({ data: { onboarding: { done: true, supplier: data?.supplier ?? null, kwh: data?.kwh ?? null } } }),
    });
    return res.ok;
  } catch { return false; }
}

// Efface de cet appareil les réponses d'un compte (après suppression du compte)
export function clearOnboarding(userId) {
  if (!userId) return;
  try { localStorage.removeItem(doneKey(userId)); localStorage.removeItem(dataKey(userId)); } catch { /* stockage indisponible */ }
}
